import { connect } from 'react-redux'
import AdminK8NoClassesCreated from './component'
import NavigationHelper from 'layers/navigation/navigationHelper'

export default connect(
  null,
  NavigationHelper.mapDispatchToProps,
)(AdminK8NoClassesCreated)
